import { AlertInline, Card } from "@fpsoftware/mvp";
import { zodResolver } from "@hookform/resolvers/zod";
import type { ComponentProps, FC } from "react";
import { useForm } from "react-hook-form";
import { TbMail } from "react-icons/tb";
import { Link } from "react-router-dom";
import { SessionRequestBodySchema } from "shared";
import { Button } from "@/components/Button";
import { FormGroup } from "@/components/form/FormGroup";
import { Input } from "@/components/form/Input";
import { LinkGen } from "@/LinkGen";
import { useAuth } from "./useAuth";

export const AuthCard: FC<ComponentProps<typeof Card>> = (props) => {
  const { requestSession } = useAuth();
  const { register, handleSubmit, formState } = useForm({
    resolver: zodResolver(SessionRequestBodySchema),
  });

  const onSubmit = handleSubmit((values) => {
    return requestSession.mutateAsync({
      email: values.email,
    });
  });

  return (
    <Card {...props}>
      <form onSubmit={onSubmit}>
        <Card.Body>
          <Card.Title>Login</Card.Title>
          <AlertInline className="mb-2" />
          <div className="mb-3">
            Enter your email below and we will send you a login link. Just press
            the login button - there is no need for a password.
          </div>
          <fieldset disabled={formState.isSubmitting}>
            <FormGroup
              label="Email"
              htmlFor="email"
              error={formState.errors.email?.message}
            >
              <Input
                placeholder="Your email address"
                id="email"
                {...register("email")}
              />
            </FormGroup>
          </fieldset>
          <Button
            full
            type="submit"
            loading={formState.isSubmitting}
            icon={TbMail}
          >
            Send email
          </Button>
          <div style={{ marginTop: "1rem", textAlign: "center" }}>
            Don't have an account? <Link to={LinkGen.SignUp()}>Sign up</Link>
          </div>
        </Card.Body>
      </form>
    </Card>
  );
};
